export default {
  common: {
    required: 'Required',
    clearAll: 'Clear All',
    restart: 'Restart'
  },
  error: {
    oops: 'OOPS!',
    restart: "Looks you're trying to get into something we are still developing...",
    tryAgain: 'Please try again, if this error continue, contact Metrica Sports support team',
    userKey:
      'Key is not valid. Check your key and try again or delete the field to complete registration',
    emailTaken: 'This email has already been taken',
    fieldTooLong: 'Some fields are too long. Shorten them and try again',
    downloadPlay: 'If you already have an account, download the latest version of Play and log in.'
  },
  createUser: {
    title: 'Get started with %{product}',
    signUpHere: 'Create your account to get started.',
    alreadyHaveAccount: 'Already have an account? %{pre}Download%{post}',
    name: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    phoneCode: 'Country',
    searchPhoneCode: 'Search...',
    clubCompany: 'Organization/Club',
    userKeyField: 'Have a Promo Code or User Key? Fill in this field',
    invalidEmail: 'Invalid email',
    createdSuccessfully:
      'Registration successful! Check your registered email for a verification link. (Check spam folder)',
    checkEmail: 'In the meantime, download Metrica Play to your computer',
    job: 'Job/Role',
    noMatches: 'No matches, write your own option',
    noCustomOption: 'Option not available',
    sport: 'Sport',
    password: 'Password',
    repeatPassword: 'Repeat Password',
    passwordsDontMatch: "Passwords don't match",
    passwordInvalid: "Password doesn't meet the requirements",
    passwordRequirements: {
      minLength: 'At least %{count} characters',
      uppercase: 'One uppercase letter',
      lowercase: 'One lowercase letter',
      number: 'One number (0-9)',
      maxLength: 'At most %{count} characters'
    },
    submitting: 'Starting...',
    proceed: 'Continue',
    signAgreement:
      'Signing up for a Metrica Sports account means you agree to the %{pre1}Privacy Policy%{post1} and %{pre2}Terms of Service%{post2}'
  },
  invitation: {
    title: 'Invitation',
    subtitle:
      'By accepting this new Metrica Sports account invitation, you will be added to another Metrica Sports account.',
    description1:
      "When you're added to the new Metrica Sports account, ownership of your existing Metrica Sports account (and information contained therein) will be transferred and assigned to the new Metrica Sports account owner. All information and data currently contained in your Metrica Sports account, and any information or data saved after you accept the account change, will be visible and available to the new Metrica Sports account owner and any administrator(s) on that account to use and share with others subject to that account owner's discretion.",
    description2:
      'By clicking "I Accept My Account Change" you are agreeing to and authorizing that:',
    list1:
      'Your existing account information will be transferred to the new Metrica Sports account.',
    list2:
      'All account information transferred to your new Metrica Sports account from your current account can be managed by the new account owner and/or administrator(s).',
    list3:
      'In the new Metrica Sports account, your role will be “Member”. You will no longer have owner or administrator privileges from your current account.',
    list4:
      'You will inherit the existing settings of your new Metrica Sports account, which may be more or less restrictive depending on your role in the account and your settings can be managed by the new Metrica Sports account owner or administrator(s).',
    list5:
      'Your current settings may be altered if they conflict account settings on the new account you are joining.',
    list6:
      'Your new account might not provide access to all of the features you have in your current account.',
    list7:
      'It is not possible to reverse your account transfer once it is initiated by you and all your account information will remain in a single account.',
    list8:
      "By clicking “I Accept My Account Change”, you will become a managed member of %{pre1}%{email}%{post1}'s account and agree to Metrica Sports' %{pre2}Terms of Service%{post2} and %{pre3}Privacy Statement%{post3}.",
    acceptButton: 'I Accept My Account Change',
    cancelButton: 'Decline',
    accepting: 'Accepting...'
  },
  jobs: {
    videoAnalyst: 'Video Analyst',
    headCoach: 'Head Coach',
    assistantCoach: 'Assistant Coach',
    goalkeeperCoach: 'Goalkeeper Coach',
    dataAnalyst: 'Data Analyst',
    performance: 'Fitness & Performance',
    scout: 'Scout',
    sportsDirector: 'Sports Director',
    academyDirector: 'Academy Director',
    player: 'Player',
    formerPlayer: 'Former Player',
    doctor: 'Doctor',
    student: 'Student',
    journalist: 'Journalist',
    other: 'Other'
  },
  sports: {
    americanFootball: 'American Football',
    baseball: 'Baseball',
    basketball: 'Basketball',
    fieldHockey: 'Field Hockey',
    football: 'Football/Soccer',
    futsal: 'Futsal',
    gaelicFootball: 'Gaelic Football',
    handball: 'Handball',
    iceHockey: 'Ice Hockey',
    lacrosse: 'Lacrosse',
    netball: 'Netball',
    padel: 'Padel',
    rugby: 'Rugby',
    tennis: 'Tennis',
    volleyball: 'Volleyball',
    other: 'Other'
  }
}
